import React, { FunctionComponent } from 'react'

import FormBuilder, {
  FormBuilderProps,
  PuxFormType,
} from '../builders/FormBuilder'
import WidgetContainer from '../builders/WidgetContainer'

const WidgetPuxFormWrapper: FunctionComponent<PuxFormType> = (props) => {
  const newProps = {
    formBuilderData: props,
  } as FormBuilderProps
  return (
    <>
      <WidgetContainer
        {...props?.puxWidgetProperties}
        {...props?.puxWidgetAnimation}
        {...props?.metadata}
        customClassName='WidgetContainer--form'
      >
        <div className='PuxFormWrapper'>
          <FormBuilder {...newProps} />
        </div>
      </WidgetContainer>
    </>
  )
}

export default WidgetPuxFormWrapper
